import { create } from "zustand";

interface SourceManagementState {
  activeSourceMessageId: string | null;
  activeSourceId: string | null;
  videoTime: number | null;

  setActiveSource: (messageId: string, sourceId: string, videoTime: number) => void;
  inactiveCurrentSource: () => void;
  hasActiveSource: () => boolean;
  setVideoTime: (time: number) => void;
}

export const useGlobalSourceManagementStore = create<SourceManagementState>((set, get) => {
  return {
    activeSourceId: null,
    activeSourceMessageId: null,
    videoTime: null,
    setActiveSource: (messageId: string, sourceId: string, videoTime: number | null) => {
      set({ activeSourceId: sourceId, activeSourceMessageId: messageId,  videoTime })
    },
    inactiveCurrentSource: () => {
      set({ activeSourceId: null, activeSourceMessageId: null, videoTime: null })
    },
    hasActiveSource: () => {
      const currentState = get();
      return currentState.activeSourceId !== null && 
             currentState.activeSourceMessageId !== null;
    }, 
    setVideoTime: (time: number) => {
      set((prev) => ({...prev, videoTime: time }));
    }
  }
})